class Gallery {

    constructor() {
        $('.gallery').on('click', '.card', e => {
            $(e.currentTarget).closest('.gallery').find('.is-flipped').removeClass('is-flipped');
            e.currentTarget.classList.add('is-flipped');
        });
    }

}
